import { metricData } from './metricDataHC'


export default metricData
